import React from 'react';

export const isAutomatedMetric = (metric) =>
  metric?.data_source_type === 'automated' || metric?.data_source_name === 'bigquery';

export const AutomatedBadge = () => (
  <span
    style={{
      marginLeft: '0.5rem',
      padding: '0.1rem 0.45rem',
      fontSize: '0.75rem',
      borderRadius: '4px',
      background: '#e8f4f8',
      color: '#034955',
      fontWeight: 600,
      verticalAlign: 'middle',
    }}
  >
    Automated
  </span>
);

export const AutoValueBadge = () => (
  <span
    style={{
      marginLeft: '0.5rem',
      padding: '0.1rem 0.35rem',
      fontSize: '0.7rem',
      borderRadius: '4px',
      background: '#f0f4f8',
      color: '#495057',
      fontWeight: 600,
    }}
  >
    Auto
  </span>
);

export const confirmAutomatedValueEdit = (metricValue) => {
  if (!metricValue?.is_automated) {
    return true;
  }
  return window.confirm(
    'This value is synced from BigQuery. Editing the value will be overwritten on the next weekly sync. Continue?'
  );
};
